import React, { useEffect, useMemo, useState } from "react";
import { Typography, Stack, ListSubheader, Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { abmActions } from "../../../redux/actions/abm.actions";
import { useFlowContext } from "../../contexts/Flow";
import { getAllParentsNodes } from "./HelperFunctions";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useDrag } from 'react-dnd'
import { ItemTypes } from "./DialogNode";

export const libraries = {
  NodeBasic:(props) => <OutputsLibrary {...props} />, 
  NodeIterator:(props) => <OutputsLibrary {...props} />, 
  NodeProcess:(props) => <OutputsLibrary {...props} />, 
  NodeUI: (props) => <OutputsLibrary {...props} />,
  EdgeEdit: (props) => <OutputsLibrary {...props} />,
}


const OutputsLibrary = ({fmk, formData}) => {
  
  const { id } = fmk.values;
  const [ expanded, setExpanded ] = useState();
  const [ node, setNode ] = useState();
  const { flowData } = useFlowContext();

  const [ parents, setParents ] = useState([]);
  
  const parametros = useMemo(()=>{
    if(!formData.parent.parametros || formData.parent.parametros.length === 0) return null;
    return {
      id: "_Parámetros", 
      nombre: "Parámetros", 
      info: formData.parent.parametros.map(item => ({nombre: item.nombre, tipoDato: item.valor}))
    };
  }, [formData])

  useEffect(()=>{
    const allParents = getAllParentsNodes(id, flowData.get()).reduce((prev, curr) => prev.some(item => item.id === curr.id) ? prev : [...prev, curr], []);
    //console.log({allParents, fmk, formData});
    const parentsInfo = allParents.map(node => {
      const {id, nombre, idPrimitiva, idTemplate} = node ? node.data : {};
      return {id, nombre, idPrimitiva, idTemplate};
    });
    setParents(parentsInfo.map(parent => ({...parent, disabled: true})));
  }, [id])
  
  const updateParent = (item) => {
    setParents(parents => parents.map(parent => parent.id !== item.id ? parent : item ))
  }

  const handleChangeSelection = (item) => {
    if (item.id === expanded){
      setNode(null);
      setExpanded(null);
    }else{
      setNode(item);
      setExpanded(item.id);
    }
  }


  return (
    <>
      {((parents && parents.length > 0) || parametros) && 
        <div style={{width: 300, overflowY: "scroll", maxHeight: "96vh"}}>
          <ListSubheader style={{width:"100%"}} component="div" id="nested-list-subheader">
            Salidas disponibles
          </ListSubheader>
          {parametros &&         
            <Accordion elevation={0} onChange={() => handleChangeSelection(parametros)}  expanded={parametros.id === expanded}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ maxHeight: "unset !important", minHeight: 20}}
              >
                <Typography>{parametros.nombre}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <OutputParamsInfo item={parametros}/>
              </AccordionDetails>
            </Accordion>
          }
          {parents && parents.map(parent =>
            <Accordion className={parent.disabled ? "d-none" : ""} key={parent.id} elevation={0} onChange={() => handleChangeSelection(parent)}  expanded={parent.id === expanded} disabled={parent.disabled}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ maxHeight: "unset !important", minHeight: 20}}
              >
                <Typography>{parent.nombre}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <OutputLibraryInfo updateParent={updateParent} item={parent}/>
              </AccordionDetails>
            </Accordion>

          )}
        </div>
      }
    </>
  )
}

const OutputParamsInfo = ({item}) => {

  const { id, info } = item; 
  const [ expanded, setExpanded ] = useState("");
  const nombre = "_operacion";

  return (
    <>
      {info && 
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="stretch"
          spacing={0.5}
          padding={0}
          width= "100%"
        >
            {
              info.map(itemInfo => 
                <LibraryItem key={itemInfo.nombre} {...itemInfo} nombreNodo={nombre} onExpand={()=>setExpanded(expanded => expanded === itemInfo.nombre ? "" : itemInfo.nombre)} expanded={itemInfo.nombre === expanded}/>
              )
            }             
        </Stack>    
      }
    </>
  )
}

const OutputLibraryInfo = ({item, updateParent}) => {

  const { id, nombre, idTemplate, idPrimitiva } = item; 
  const dispatch = useDispatch();
  const [ info, setInfo ] = useState();
  const [ expanded, setExpanded ] = useState("");

  useEffect(()=>{
    if(!idTemplate && !idPrimitiva) return;
    dispatch(abmActions("operaciones").getFlowOutputs({idTemplate, idPrimitiva}))
    .then( response => {
      if(response.value.length > 0){
        updateParent({...item, disabled: false});
        setInfo(response.value)      
      }
    })
    .catch(e => {
      setInfo(null)
    })
    .finally(()=>{})
  }, [idTemplate, idPrimitiva]);

  return (
    <>
      {info && 
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="stretch"
          spacing={0.5}
          padding={0}
          width= "100%"
        >
            {
              info.map(itemInfo => 
                <LibraryItem key={itemInfo.nombre} {...itemInfo} nombreNodo={nombre} onExpand={()=>setExpanded(expanded => expanded === itemInfo.nombre ? "" : itemInfo.nombre)} expanded={itemInfo.nombre === expanded}/>
              )
            }             
        </Stack>    
      }
    </>
  )
}

const LibraryItem = ({nombreNodo, nombre, tipoDato, descripcion, onExpand, expanded}) => {

  const [{isDragging}, drag] = useDrag(() => ({
    type: ItemTypes.LIBRARY_ITEM,
    item: {value: `${nombreNodo}.${nombre}`},
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  }), [nombre, tipoDato])
  
  const [ showInfo, setShowInfo ] = useState(false);


  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move',
        border: "1px solid rgb(154, 154, 154)",
        padding: 0,
      }}
    >
      <Accordion expanded={expanded} onChange={onExpand}
      style={{ maxHeight: "unset !important", minHeight: 20, marginTop: 4, marginBottom: 4}}>
        <AccordionSummary
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{ maxHeight: "unset !important", minHeight: 20, marginTop: 4, marginBottom: 4}}
        >        
          <span
            style={{
              fontWeight: "bold"
            }}
          >{nombre}</span>
        </AccordionSummary>
        <AccordionDetails >
          {tipoDato}<br/>{descripcion}
        </AccordionDetails>
      </Accordion>
    </div>
  )

}
